<template>
  <div id="map-chart" :style="styles"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "map-chart",
  props: {
    map_name: {
      type: String,
      default: "china",
    },
    text: {
      type: String,
      default: "产量",
    },
    projects: Array,
    styles: String,
    is_jump: {
      type: Boolean,
      default: false,
    },
    is_loading: Boolean,
  },
  data() {
    return {
      map: {},
    };
  },
  watch: {
    projects(new_val) {
      this.map.showLoading();
      this.projects = new_val;
      this.draw();
    },
    map_name(new_val) {
      this.map.showLoading();
      this.map_name = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.map.showLoading() : this.map.hideLoading();
    },
  },
  mounted() {
    this.map = echarts.init(document.getElementById("map-chart"));
    this.map.showLoading();
  },
  methods: {
    draw() {
      if (this.projects === undefined) {
        this.map.hideLoading();
        return;
      }

      let _this = this;
      let map_json = require("@/assets/js/map-json/" + this.map_name + ".json");
      echarts.registerMap(this.map_name, map_json);
      var mapData = [];
      var maxVolume = 0;

      maxVolume = Math.max.apply(
        Math,
        this.projects.map((item) => {
          return item.volume;
        })
      );
      maxVolume =
        Number(Number(maxVolume.toString().substring(0, 2)) + 1) *
        Math.pow(10, maxVolume.toString().length - 2);

      for (let item of this.projects) {
        mapData.push({
          name:
            _this.map_name === "china"
              ? Object.values(item)[0]
              : Object.values(item)[0] + "市",
          value: Object.values(item)[1],
        });
      }

      if (this.map_name === "china") {
        mapData.push({ name: "宁夏", value: 0 });
        mapData.push({ name: "西藏", value: 0 });
        mapData.push({ name: "青海", value: 0 });
        mapData.push({ name: "香港", value: 0 });
        mapData.push({ name: "澳门", value: 0 });
        mapData.push({ name: "台湾", value: 0 });
        mapData.push({ name: "南海诸岛", value: 0 });
        mapData.push({ name: "钓鱼岛", value: 0 });
        mapData.push({ name: "赤尾屿", value: 0 });
      }

      let option = {
        color: ["#00578F"],
        tooltip: {
          borderColor: "#FFFFFF",
        },
        // title: {
        //   text: _this.text,
        //   left: "left",
        //   top: "bottom",
        //   padding: [20, 5],
        //   // padding: [66, 60],
        //   textStyle: {
        //     color: "#666",
        //     fontSize: 12,
        //   },
        // },
        visualMap: {
          type: "piecewise",
          min: 0,
          max: maxVolume,
          // splitNumber:5,
          // left: "40",
          splitNumber: 7,
          inRange: {
            color: [
              "#E5F0FF",
              "#B1D1FD",
              "#86B9FF",
              "#519AFB",
              "#0080FF",
              "#0B6EF4",
            ],
            symbolSize: [30, 100],
          },
          pieces: [
            { value: 0 }, // 表示 value 等于 123 的情况。
            { min: 1, max: parseInt(maxVolume / 5) - 1 },
            {
              min: parseInt(maxVolume / 5),
              max: parseInt((maxVolume / 5) * 2) - 1,
            },
            {
              min: parseInt((maxVolume / 5) * 2),
              max: parseInt((maxVolume / 5) * 3) - 1,
            },
            {
              min: parseInt((maxVolume / 5) * 3),
              max: parseInt((maxVolume / 5) * 4) - 1,
            },
            { min: parseInt((maxVolume / 5) * 4), max: maxVolume - 1 }, // 不指定 max，表示 max 为无限大（Infinity）。
          ],
          bottom: "0",
          padding: [20, 20],
          orient: "horizontal",
          inverse: !1,
          text: ["高", "低"],
          seriesIndex: [1],
          color: ["#0B6EF4", "#E5F0FF"],
          itemSymbol: "rect",
          itemGap: 3,
          textGap: 11,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#999",
          },
        },
        geo: {
          map: this.map_name,
          zoom: 1.1,
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "rgba(0, 0, 0, 0.4)",
              },
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#000",
              },
            },
          },
          itemStyle: {
            normal: {
              borderColor: "#FFF",
              areaColor: "#f1f4f6",
              borderWidth: 1,
            },
            emphasis: {
              areaColor: "#004DB3",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 8,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.2)",
            },
          },
        },
        series: [
          {
            name: "",
            type: "scatter",
            coordinateSystem: "geo",
            symbolSize: function (t) {
              return t[2] / 10;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: !1,
              },
              emphasis: {
                show: !0,
                color: "#000",
              },
            },
            itemStyle: {
              normal: {
                color: "#8ADEFA",
              },
            },
          },
          {
            name: "",
            type: "map",
            geoIndex: 0,
            label: {
              normal: {
                show: false,
                textStyle: {
                  color: "rgba(0, 0, 0, 0.4)",
                },
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#000",
                },
              },
            },
            itemStyle: {
              normal: {
                color: "#3DC8F7",
              },
            },
            tooltip: {
              show: true,
              formatter: function (params) {
                if (params.data) {
                  return (
                    params.name +
                    "<br/>" +
                    _this.text +
                    "：" +
                    params.data.value.toLocaleString()
                  );
                } else {
                  return "";
                }
              },
            },
            data: mapData,
          }
        ],
      };
      _this.map.clear();
      _this.map.setOption(option, true);
      _this.map.hideLoading();
      const cityArr = this.$store.state.cityArr;
      _this.map.off("click");
      if (this.is_jump) {
        _this.map.on("click", function (param) {
          var cityName = param.name;
          for (var i = 0, len = cityArr[0].length; i < len; i++) {
            if (cityName == cityArr[0][i]) {
              _this.$router.push({
                name: "map-provience",
                params: { data_type: "production", provience: cityArr[3][i] },
              });
              return;
            }
          }
          _this.$router.push({
            name: "map",
            params: { data_type: "production" },
          });
          return;
        });
      } else {
        _this.map.on("click", function (param) {
          var province_name =
            param.name.substr(param.name.length - 1, param.name.length) === "市"
              ? param.name.substr(0, param.name.length - 1)
              : param.name;
          if (document.getElementsByName(province_name).length > 0) {
            document.getElementsByName(province_name)[document.getElementsByName(province_name).length - 1].click();
            document.getElementById("btn_query").click();
          }
        });
      }

      // _this.map.dispatchAction({
      //     type: 'showTip',
      //     seriesIndex: 1,
      //     dataIndex: mapData.findIndex(function (itm) { return itm.name == "钓鱼岛" })
      // });

      // _this.map.dispatchAction({
      //       type: 'showTip',
      //       seriesIndex: 0,
      //       dataIndex: mapData.findIndex(function (itm) { return itm.name == "上海" }),
      //   });
        _this.map.dispatchAction({
            type: 'highlight',
            seriesIndex: 1,
            dataIndex: [31, 32, 33, 34, 35, 36]
            // dataIndex: mapData.findIndex(function (itm) { return itm.name == "上海" }),
        });
    },
  },
};
</script>
